import { useContext } from 'react';
import { IdentityContext, type IdentityContextValue } from './IdentityContext';

export function useIdentity(): IdentityContextValue {
  const context = useContext(IdentityContext);
  if (!context) {
    throw new Error('useIdentity must be used within an IdentityProvider.');
  }
  return context;
}
